__turbopack_context__.v({
  "desc-con": "resumeJourneyCard-module-scss-module__f_OSBa__desc-con",
  "health-bg": "resumeJourneyCard-module-scss-module__f_OSBa__health-bg",
  "image": "resumeJourneyCard-module-scss-module__f_OSBa__image",
  "main-con": "resumeJourneyCard-module-scss-module__f_OSBa__main-con",
  "mobile-view": "resumeJourneyCard-module-scss-module__f_OSBa__mobile-view",
  "text-con": "resumeJourneyCard-module-scss-module__f_OSBa__text-con",
  "vehicle-image": "resumeJourneyCard-module-scss-module__f_OSBa__vehicle-image",
});
